import React from 'react';

import {Button, Dialog, DialogContent, Grid, TextField} from '@material-ui/core';

import DialogHeader from '../../../../components/dialogs/dialog-header';

type Props = {
  isOpen: boolean;
  clonedWorkspaceName: string;
  error: boolean;
  setClonedWorkspaceName(arg0: string): void;
  onSave(): Promise<void>;
  onClose(): void;
};

const CloneWorkspaceView: React.FC<Props> = ({
  isOpen,
  clonedWorkspaceName,
  error,
  setClonedWorkspaceName,
  onClose,
  onSave,
}) => {
  return (
    <Dialog arial-labelledby={'clone-workspace-title'} onClose={onClose} open={isOpen}>
      <DialogHeader handleClose={onClose} id={'clone-workspace-title'}>
        Clone a new Workspace
      </DialogHeader>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              error={error}
              fullWidth
              helperText={error && 'Please enter a workspace name with at least one character'}
              label={'Workspace name'}
              onChange={(event) => setClonedWorkspaceName(event.currentTarget.value)}
              value={clonedWorkspaceName}
            />
          </Grid>
          <Grid item xs={12}>
            <Button color={'primary'} onClick={onSave} variant={'contained'}>
              Clone
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CloneWorkspaceView;
